import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { UrlService } from '@appShared/services/url.service'
import { LmsModuleListComponent } from '@appContent/components/module-list/module-list.component'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-content-course-library',
    templateUrl: './course-library.component.html',
    styleUrls: ['./course-library.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LmsModuleListComponent]
})
export class CourseLibraryComponent implements OnInit {
   courses = SITE_DIRECTORY_ROUTES.content

   constructor(
      private _urlService: UrlService,
      titleService: Title
   ) {
      titleService.setTitle(this.courses.title)
   }

   ngOnInit() {
      //they don't want header for now since page had a header
      //setTimeout(() => { this._urlService.setHeaderTitle(this.courses.title) })

      setTimeout(() => { this._urlService.setHeaderTitle('') })
   }

   /*
   * private methods
   * */

   /*
   * public methods
   * */
}
